import React from 'react';

const getFallbackLabel = (mediaType) => {
  if (mediaType === 'audio') return '音频';
  if (mediaType === 'video') return '视频';
  return '主体';
};

const SubjectChips = ({
  subjects,
  activeMentionKey,
  onFocusSubject,
  onRemoveSubject,
}) => {
  if (!subjects.length) {
    return null;
  }

  return (
    <div className='mention-tags creator-subject-chips'>
      {subjects.map((subject) => (
        <div
          key={subject.id}
          className={`mention-tag${activeMentionKey.startsWith(`${subject.id}:`) ? ' active' : ''}`}
          onClick={() => onFocusSubject(subject)}
          role='button'
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onFocusSubject(subject);
            }
          }}
        >
          {subject.imageUrl ? (
            <img className='mention-tag-img' src={subject.imageUrl} alt={subject.name} />
          ) : (
            <span className='mention-tag-dot'>
              {subject.mediaType === 'audio' ? '♫' : subject.mediaType === 'video' ? '▶' : '•'}
            </span>
          )}
          <span className='mention-tag-name'>{subject.name}</span>
          <button
            className='mention-tag-remove'
            onClick={(e) => {
              e.stopPropagation();
              onRemoveSubject(subject);
            }}
          >
            &times;
          </button>
          <span className='mention-tag-preview'>
            {subject.mediaType === 'video' && subject.sourceUrl ? (
              <video
                className='mention-tag-preview-media mention-tag-preview-video'
                src={subject.sourceUrl}
                muted
                autoPlay
                loop
                playsInline
                preload='metadata'
              />
            ) : subject.imageUrl ? (
              <img
                className='mention-tag-preview-media'
                src={subject.imageUrl}
                alt={subject.name}
              />
            ) : (
              <span className='mention-tag-preview-fallback'>
                {getFallbackLabel(subject.mediaType)}
              </span>
            )}
            <span className='mention-tag-preview-name'>{subject.name}</span>
          </span>
        </div>
      ))}
    </div>
  );
};

export default SubjectChips;
